import { Avatar, Box, Grid, Typography, IconButton, Stack } from '@mui/material';
import { useEffect, useState, useContext } from 'react';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { ArrowBackIos, ArrowForwardIos } from '@mui/icons-material';
import PlaceIcon from "@mui/icons-material/Place";
import ExpandIcon from "../../../../../../../../assets/images/icons/expand_icon.png";
import { ParsingAmount } from "../../../../../../../../core/validator/Validator";
import { ToolContext } from '../../../../../../../../core/context/ToolContext';

export const View = ({ viewId }) => {
    const { website_state } = useContext(ToolContext)
    const { preview } = { ...website_state };
    const urlParams = new URLSearchParams(window.location.search);
    const [filter, setFilter] = useState(null);

    useEffect(() => {
        const id = parseInt(viewId);
        const filtered = preview.data.list.find(item => item.id === id);
        setFilter(filtered || null);
        // eslint-disable-next-line
    }, [urlParams, preview.data.list]);

    return (
        <Box width="100%" height="100%">
            <Box width="100%" height="100%" display="flex" flexDirection="column" alignItems="center" gap={2}>
                {filter ? (
                    <Box width="100%" height="100%" p="1rem" className="overflowY">
                        <Box width="100%">
                        <Box fontSize="0.75rem" color="#19191A" fontWeight={600} lineHeight="18px" mb="1rem" >Top Listings</Box>
                            <Box height="198px">
                                <Box
                                    component="img"
                                    src={filter.coverPhoto.object}
                                    alt="Cover Photo"
                                    sx={{ height: "100%", width: "100%", objectFit: 'cover', borderRadius: "12px", display: filter.coverPhoto.object ? 'block' : 'none' }}
                                />
                            </Box>
                            <Box sx={{ position: "relative", my: "0.5rem", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                <Stack sx={{ overflowX: "hidden", mx: "1.5rem" }}>
                                    <Box sx={{ display: "flex", columnGap: "0.5rem", justifyContent: "flex-start", alignItems: "center" }}>
                                        {filter.normal_photos &&
                                        Object.values(filter.normal_photos).map((p, k) => (
                                            <Avatar key={k} src={p.link} alt={p.name}
                                                sx={{ width: "4rem", height: "4rem", borderRadius: "10px" }}
                                            />
                                        ))}
                                    </Box>
                                </Stack>
                                <IconButton sx={{ cursor: "default", position: "absolute", top: "50%", left: 0, transform: "translateY(-50%)", p: "0" }}>
                                    <ArrowBackIos sx={{ fontSize: "1.4rem", fontWeight: "bold" }} />
                                </IconButton>
                                <IconButton sx={{ cursor: "default", position: "absolute", top: "50%", right: "-0.313rem", transform: "translateY(-50%)", p: "0" }}>
                                    <ArrowForwardIos sx={{ fontSize: "1.4rem", fontWeight: "bold" }} />
                                </IconButton>
                            </Box>
                        </Box>

                        <Box width="100%" mt={2}>
                            <Box textAlign="center" fontSize="1.25rem" fontWeight={600} lineHeight="30px" mb="7px"> 
                                {filter.title.value}
                            </Box>
                            <Box display="flex" alignItems="center" mt="0.6rem">
                                <PlaceIcon fontSize="1rem" sx={{mr: "0.5rem"}}/>
                                <Box fontSize="0.625rem" lineHeight="18px" fontWeight={500} sx={{ textTransform: 'uppercase' }}>
                                    {filter.location.city}, {filter.location.province}
                                </Box>
                            </Box>
                            <Box display="flex" alignItems="center" mt="4px">
                                <Avatar src={ExpandIcon} sx={{ height: "13px", width: "13px" }}/>
                                <Box fontSize="0.625rem" lineHeight="15px" fontWeight={500} ml="10px">
                                    40 m <sup>2</sup>
                                </Box>
                            </Box>
                            <Box>
                                <Stack direction="row" alignItems="center" gap={1} mt="1rem">
                                    <Typography fontSize={20} lineHeight="15px" fontWeight={600} sx={{ minWidth: "3.2rem", color: "#ff8c00" }}>{"Price "} </Typography>
                                    <Typography fontSize={20} lineHeight="16px" fontWeight={600} sx={{ color: "#ff8c00" }} >&#8369; {ParsingAmount(filter.price.value)}</Typography>
                                </Stack>
                            </Box>
                            <Box mt="1rem">
                                <Typography fontSize="0.875rem" lineHeight="18px" fontWeight={600} color="#19191A" mb="8px">Overview</Typography>
                                <Typography fontSize="0.75rem" lineHeight="15px" fontWeight={500} dangerouslySetInnerHTML={{ __html: filter.description.value }}/>
                            </Box>
                            <Box mt="0.7rem">
                                <Typography fontSize="0.875rem" lineHeight="18px" fontWeight={600} color="#19191A" mb="8px">Indoor Activities</Typography>
                                <Grid container sx={{ px: "1rem" }}>
                                    {filter.indoor?.map((v, k) => (
                                        <Grid key={k} item xs={6} >
                                            <Typography lineHeight="15px" sx={{ fontSize: "0.75rem", fontWeight: "400" }}>• {v}</Typography>
                                        </Grid>
                                    ))}
                                </Grid>
                            </Box>
                            <Box mt="0.7rem">
                                <Typography fontSize="0.875rem" lineHeight="18px" fontWeight={600} color="#19191A" mb="8px">Outdoor Activities</Typography>
                                <Grid container sx={{ px: "1rem" }}>
                                    {filter.outdoor?.map((v, k) => (
                                        <Grid key={k} item xs={6} >
                                            <Typography lineHeight="15px" sx={{ fontSize: "0.75rem", fontWeight: "400" }}>• {v}</Typography>
                                        </Grid>
                                    ))}
                                </Grid>
                            </Box>
                            <Box mt="0.6rem">
                                <Typography fontSize="0.875rem" lineHeight="18px" fontWeight={600} color="#19191A" mb="8px">Contact Details</Typography>
                                <Box sx={{ display: "flex", alignItems: "center", ml: "1rem" }}>
                                    <Avatar />
                                    <Box sx={{ ml: "0.8rem" }}>
                                        <Typography sx={{ fontSize: "0.8rem" }}>{filter.contact_details.first_name} {filter.contact_details.last_name}</Typography>
                                        <Typography sx={{ fontSize: "0.8rem", mt: "8px" }}>{filter.contact_details.email} </Typography>
                                        <Typography sx={{ fontSize: "0.8rem", mt: "8px" }}>{filter.contact_details.cellphone_number}</Typography>
                                    </Box>
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                ) : (
                    <Box height="100%" width="100%" display="flex" alignItems="center" justifyContent="center">
                        <Box fontSize={24} fontWeight={700} color="#CECECE">No data found</Box>
                    </Box>
                )}
            </Box>
        </Box>
    );
};
